exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#root .pagination-wrapper{white-space:nowrap}#root .pagination-wrapper .page-input{display:inline-block;height:34px;margin-right:5px}#root .pagination-wrapper button.Button{border:0;box-shadow:none;color:#7a7a7a;height:34px}#root .pagination-wrapper button.Button:hover{color:#94040f}#root .pagination-wrapper button.Button--primary,#root .pagination-wrapper button.Button--primary:hover{color:#fff}#root .pagination-wrapper i{font-size:1.2em}#root .pagination-wrapper input{width:42px;padding:0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/components/Pagination/Pagination.scss
// module id = 740
// module chunks = 0